import { render, staticRenderFns } from "./ProductTypeBrandComponent.vue?vue&type=template&id=4ef38dee"
import script from "./ProductTypeBrandComponent.vue?vue&type=script&lang=js"
export * from "./ProductTypeBrandComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports